import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Deepak Poudel</span>{" "}
            from <span className="purple">Kathmandu, Nepal</span>.
            <br />
            I’m currently learning and building projects related to {" "}
            <span className="purple">DevOps and DevSecOps as well as projects in Python and Django framework</span>{" "}
            <span className="purple"></span>.
            <br />I have completed my Bachelor in Information Management (BIM) from{" "}
            <span className="purple">Thames International College.</span>.
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies and TV Shows 📺
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>

            <li className="about-activity">
              <ImPointRight /> Reading Books 📚
            </li>
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
